import React from "react";
import { Box, Typography, Chip, Card, CardContent, Alert } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { TIER_CARD } from "../PaymentSetup.constants";

const NEAR_THRESHOLD_MARGIN = 2; // sessions/week within next tier threshold

const TierCard = ({ currentTier }) => {
  if (!currentTier) return null;

  const { weeklyAverage, nextTierThreshold } = currentTier;

  // Determine if practitioner is approaching the next tier threshold
  const isNearNextTier =
    nextTierThreshold &&
    weeklyAverage > 0 &&
    weeklyAverage >= nextTierThreshold.minWeeklyAvg - NEAR_THRESHOLD_MARGIN;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {TIER_CARD.TITLE}
        </Typography>
        <Box display="flex" alignItems="center" gap={2} mb={1}>
          <Chip
            label={`Tier ${currentTier.tier}`}
            color="primary"
            sx={{ fontWeight: 600, fontSize: "1rem", px: 2, py: 1 }}
          />
        </Box>
        {/* Revenue split display removed per March 11 decision — showing only 70/30 may be misleading without full tier context */}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {TIER_CARD.TIER_DESCRIPTION}
        </Typography>
        {weeklyAverage > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {TIER_CARD.ACTIVITY_PREFIX}{weeklyAverage}{TIER_CARD.ACTIVITY_SUFFIX}
          </Typography>
        )}
        {isNearNextTier && (
          <Alert
            severity="info"
            icon={<TrendingUpIcon />}
            sx={{ mt: 2 }}
          >
            {TIER_CARD.NEAR_THRESHOLD_PREFIX}{weeklyAverage}{TIER_CARD.NEAR_THRESHOLD_MID}
            {nextTierThreshold.tier}{TIER_CARD.NEAR_THRESHOLD_AT}
            {nextTierThreshold.minWeeklyAvg}{TIER_CARD.NEAR_THRESHOLD_SUFFIX}
          </Alert>
        )}
      </CardContent>
    </Card>
  );
};

export default TierCard;
